var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "rocket"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M17.9869 14.2337L7.47466 24.7459M8.60915 17.1167L3.46008 15.9005C2.89358 15.7666 2.69434 15.0633 3.10472 14.6515L7.19958 10.5566C7.47466 10.2815 7.84786 10.1239 8.23891 10.1209L12.8557 10.0808M18.6709 4.79791C22.107 7.14124 25.0793 10.1135 27.4226 13.5497M15.1024 23.6114L16.3186 28.7605C16.4524 29.327 17.1557 29.5262 17.5676 29.1158L21.6625 25.021C21.9375 24.7459 22.0952 24.3727 22.0981 23.9816L22.1383 19.3649M28.3044 11.1335L29.5058 5.35252C29.8329 3.7794 28.4412 2.38768 26.868 2.71479L21.087 3.91619C19.3846 4.27007 17.8233 5.11313 16.5952 6.34278L11.852 11.0844C10.0425 12.894 8.86489 15.2403 8.49317 17.7724L8.47681 17.881C8.24189 19.4972 8.78311 21.1283 9.93693 22.2836C11.0908 23.4375 12.7233 23.9787 14.3396 23.7423L14.4481 23.7259C16.9803 23.3557 19.3266 22.1766 21.1361 20.367L25.8778 15.6254C27.1074 14.3972 27.9505 12.836 28.3044 11.1335Z",
    stroke: "#0C4ACF",
    strokeWidth: 2.625,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.82e435c26f16ebcfd729c893d18dac54.svg";
export { ForwardRef as ReactComponent };